import React from "react";
import { ButtonGroup } from "@mui/material";
import { NewReminderHelper } from "../reminders/NewReminderHelper";
import SupportButton from "./SupportButton";
import HelpButton from "./HelpButton";

const ButtonGroupComponent = ({ route, visible, setUpdateReminders }) => {
  return (
    <ButtonGroup
      variant="contained"
      orientation="vertical"
      className="button-group"
    >
      {visible && (
        <NewReminderHelper
          setUpdateReminders={setUpdateReminders ? setUpdateReminders : false}
        />
      )}
      <HelpButton route={route} />
      <SupportButton />
    </ButtonGroup>
  );
};

export default ButtonGroupComponent;
